export const ChartIds = {
  Vessel_Speed: 'Vessel_Speed',
  Heading_Course: 'Heading_Course',
  Air_Water_Temperature: 'Air_Water_Temperature',
  Roll: 'Roll',
  Heave: 'Heave',
  ROT: 'ROT',
  Pitch: 'Pitch',
  Throttle: 'Throttle',
  Thruster: 'Thruster',
  Thruster_Power: 'Thruster_Power',
  Thruster_Duty_Cycle: 'Thruster_Duty_Cycle',
  Voltage_12V: 'Voltage_12V',
  Current_12V: 'Current_12V',
  Temperature_12V: 'Temperature_12V',
  Voltage_48V: 'Voltage_48V',
  Current_48V: 'Current_48V',
  Temperature_48V: 'Temperature_48V',
  SOC_48V: 'SOC_48V',
  SOC_12V: 'SOC_12V',
  Rudder: 'Rudder',
  Depth: 'Depth',
  Air_Pressure: 'Air_Pressure',
  Total_Fuel_Consumption: 'Total_Fuel_Consumption',
  Engine_Power: 'Engine_Power',
  Engine_Speed: 'Engine_Speed',
  Wind_Speed: 'Wind_Speed',
  Propeller_Slip: 'Propeller_Slip',
  Drafts: 'Drafts',
  Engine_Loading: 'Engine_Loading',
  Wind_Speed_Per_Limits: 'Wind_Speed_Per_Limits',
  Engine_Speed_Limits: 'engineSpeedDistributionBar',
  Speed_Over_Ground_Limits: 'Speed_Over_Ground_Limits',
  Steaming: 'Steaming',
  Auxiliary_Engines_Power: 'Auxiliary_Engines_Power',
  Diesel_Generator_Running_Hours: 'Diesel_Generator_Running_Hours',
  Fuel_Oil_Consumption: 'Fuel_Oil_Consumption',
  Boiler_Fuel_Oil_Consumption: 'Boiler_Fuel_Oil_Consumption',
  Auxiliary_Engines_Fuel_Oil_Consumption:
    'Auxiliary_Engines_Fuel_Oil_Consumption',
} as const;

export type ChartId = (typeof ChartIds)[keyof typeof ChartIds];
